export default {
  "auth.login": "Anmelden",
  "auth.register": "Registrieren",
  "auth.email": "E-Mail-Adresse",
  "auth.password": "Passwort",
  "auth.logout": "Abmelden",
  "auth.loginFailed": "Anmeldung fehlgeschlagen",
  "auth.registerFailed": "Benutzerregistrierung fehlgeschlagen",
  "nav.dashboard": "Bewertungs-Dashboard",
  "nav.activeEvaluations": "Laufende Bewertungen",
  "nav.completedEvaluations": "Abgeschlossene Bewertungen",
  "nav.createNew": "Neue Bewertung erstellen",
  "nav.projectMerge": "Projekt-Zusammenführung",
  "nav.share": "Freigabe-Einstellungen",
  "nav.copy": "Kopieren",
  "nav.delete": "Löschen",
  "nav.settings": "Einstellungen",
  "menu.language": "Spracheinstellungen",
  "menu.colorPalette": "Farbpalette",
  "status.inProgress": "In Bearbeitung",
  "status.completed": "Abgeschlossen",
  "status.untitled": "Unbenannte Bewertung",
  "stats.subjects": "Objekte",
  "stats.criteria": "Kriterien",
  "stats.progress": "Fortschritt",
  "step.criteriaExtraction": "Kriterien-Extraktion",
  "step.comparison": "Ordnen wir sie nach Qualität",
  "step.subjectRegistration": "Objektregistrierung",
  "form.evaluationPolicy": "Bewertungsrichtlinie",
  "form.policyDescription": "Bewertungsrichtlinie und Schwerpunkte",
  "form.policyPlaceholder": "Beispiel: Logische Struktur betonen und Kreativität und Originalität bewerten",
  "btn.aiExtraction": "KI-Kriterien-Extraktion",
  "btn.manualAdd": "Kriterien manuell hinzufügen",
  "btn.next": "Weiter",
  "btn.back": "Zurück",
  "plan.free": "Kostenloser Plan",
  "plan.professional": "Professionell",
  "plan.business": "Geschäft",
  "plan.school": "Schule",
  "plan.unlimitedProjects": "Unbegrenzte Projekte",
  "plan.prioritySupport": "Vorrangiger Support",
  "plan.dataExport": "Datenexport",
  "plan.monthlyRenewal": "Monatliche automatische Erneuerung",
  "plan.cancelAnytime": "Jederzeit kündbar",
  "plan.paymentFailed": "Zahlungsinitiierung fehlgeschlagen",
  "confirm.delete": "Sind Sie sicher dass Sie löschen möchten? Diese Aktion kann nicht rückgängig gemacht werden",
  "alert.appUpdate": "Anwendungsupdate erkannt",
  "alert.projectLimit": "Sie haben das Limit für die Erstellung von Bewertungsprojekten erreicht",
  "common.loading": "Laden...",
  "common.save": "Speichern",
  "common.cancel": "Abbrechen",
  "common.confirm": "Bestätigen",
  "common.error": "Fehler",
  "common.success": "Erfolg",
  "date.today": "Heute",
  "date.yesterday": "Gestern",
  "date.thisWeek": "Diese Woche",
  "date.lastWeek": "Letzte Woche",
  "error.dashboardLoad": "Dashboard-Ladefehler",
  "error.serverUnavailable": "Verbindung zum Server nicht möglich. Bitte versuchen Sie es später erneut",
  "error.evaluationLimit": "Fehler bei der Überprüfung des Bewertungslimits",
  "error.loadingData": "Ladefehler",
  "error.copyFailed": "Kopierfehler",
  "error.deleteFailed": "Löschen fehlgeschlagen",
  "error.copyProcess": "Ein Fehler ist während des Kopiervorgangs aufgetreten",
  "error.deleteProcess": "Ein Fehler ist während des Löschvorgangs aufgetreten",
  "error.sharingUpdate": "Fehler beim Aktualisieren der Freigabe-Einstellungen",
  "msg.loadingDashboard": "Dashboard wird geladen...",
  "msg.retry": "Wiederholen",
  "msg.projectLimitReached": "Sie haben das Limit für die Erstellung von Bewertungsprojekten erreicht",
  "msg.upgradeToProPlan": "Bitte upgraden Sie auf den PRO-Plan",
  "msg.cannotCreateProject": "Bewertungsprojekt kann nicht erstellt werden",
  "msg.freeLastProject": "Der kostenlose Plan erlaubt bis zu 1 Bewertungsprojekt. Dies ist Ihr letzter verfügbarer Platz.",
  "msg.untitledProject": "Unbenanntes Bewertungsprojekt",
  "msg.welcome": "Willkommen",
  "msg.welcomeWithName": "Willkommen, {{name}}",
  "msg.created": "Erstellt",
  "msg.updated": "Aktualisiert",
  "msg.completed": "abgeschlossen",
  "copy.title": "Erstelle eine Kopie von \"{{title}}\"",
  "copy.newTitle": "Geben Sie einen neuen Titel ein (leer lassen für \"Originaltitel (Kopie)\")",
  "progress.completed": "abgeschlossen",
  "common.initializing": "Anwendung wird initialisiert...",
  "common.connecting": "Verbindung wird hergestellt...",
  "common.processing": "Verarbeitung...",
  "common.required": "Erforderlich",
  "common.close": "Schließen",
  "common.preview": "Vorschau",
  "common.edit": "Bearbeiten",
  "common.details": "Details",
  "common.position": "Position",
  "common.rank": "Rang",
  "common.placed": "Platziert",
  "common.characters": "Zeichen",
  "common.items": "Elemente",
  "common.folders": "Ordner",
  "common.files": "Dateien",
  "common.openInNewTab": "In neuem Tab öffnen",
  "common.next": "Weiter",
  "common.prev": "Zurück",
  "googleDrive.title": "Aus Google Drive importieren",
  "googleDrive.connect": "Mit Google Drive verbinden",
  "googleDrive.description": "Um Bewertungsziele aus Google Drive in größeren Mengen zu importieren, melden Sie sich bitte zuerst mit Ihrem Google-Konto an.",
  "googleDrive.signIn": "Mit Google-Konto anmelden",
  "modal.closeModal": "Modal schließen",
  "invitation.invalid": "Ungültiger Einladungstoken",
  "invitation.accepted": "Einladung angenommen",
  "invitation.failed": "Fehler beim Annehmen der Einladung",
  "invitation.title": "Einladung zum Bewertungsprojekt",
  "invitation.accept": "Einladung annehmen",
  "collaboration.viewResults": "Bewertungsergebnisse anzeigen",
  "collaboration.addComments": "Kommentare hinzufügen",
  "collaboration.downloadData": "Daten herunterladen",
  "collaboration.editCriteria": "Bewertungskriterien bearbeiten",
  "collaboration.manageProject": "Projekt verwalten",
  "autoSave.settings": "Automatische Speicherungseinstellungen",
  "autoSave.interval": "Speicherintervall",
  "autoSave.15seconds": "15 Sekunden",
  "autoSave.30seconds": "30 Sekunden",
  "autoSave.1minute": "1 Minute",
  "autoSave.2minutes": "2 Minuten",
  "autoSave.5minutes": "5 Minuten",
  "autoSave.saveNow": "Jetzt speichern",
  "autoSave.saved": "Gespeichert",
  "autoSave.helpShort": "Häufig speichern mit kurzen Intervallen",
  "autoSave.helpMedium": "Ausgewogene Speicherfrequenz",
  "autoSave.helpLong": "Ressourcen sparen mit längeren Intervallen",
  "weight.title": "Konfiguration der Gesamtbewertungsgewichtung",
  "weight.description": "Bitte legen Sie das Gewicht für jedes Bewertungskriterium fest. Das Gesamtgewicht wird auf 100% angepasst.",
  "weight.equalDistribution": "Gleichmäßige Verteilung",
  "weight.criterion": "Bewertungskriterium",
  "weight.weight": "Gewicht (%)",
  "weight.maxScore": "Maximalpunktzahl",
  "weight.saveSettings": "Einstellungen speichern",
  "preview.title": "Vorschau von {{title}}",
  "preview.iframeBlocked": "Einige Seiten können die Anzeige in iframes blockieren.",
  "preview.showPreview": "Vorschau anzeigen",
  "preview.editDetails": "Details bearbeiten",
  "preview.available": "Vorschau verfügbar",
  "googleDrive.myDrive": "Meine Ablage",
  "googleDrive.emptyFolder": "Dieser Ordner ist leer",
  "googleDrive.filesSelected": " Dateien ausgewählt",
  "googleDrive.importSelected": "Ausgewählte Dateien importieren",
  "dashboard.projectLimitReached": "Sie haben das Limit für die Erstellung von Bewertungsprojekten erreicht ({count} Projekte). Bitte upgraden Sie auf den PRO-Plan.",
  "dashboard.cannotCreateProject": "Bewertungsprojekt kann nicht erstellt werden.",
  "dashboard.freeLastProject": "Der kostenlose Plan erlaubt bis zu 1 Bewertungsprojekt. Dies ist Ihr letzter verfügbarer Platz.",
  "dashboard.evaluationLimitCheckFailed": "Fehler bei der Überprüfung des Bewertungslimits.",
  "dashboard.loadingError": "Ladefehler: {{message}}",
  "dashboard.copyError": "Kopierfehler: {{message}}",
  "dashboard.copyProcessError": "Ein Fehler ist während des Kopiervorgangs aufgetreten",
  "dashboard.deleteError": "Löschfehler: {{message}}",
  "dashboard.deleteProcessError": "Ein Fehler ist während des Löschvorgangs aufgetreten",
  "dashboard.shareSettingsUpdateFailed": "Fehler beim Aktualisieren der Freigabe-Einstellungen",
  "dashboard.copyProjectTitle": "Erstelle eine Kopie von \"{{title}}\".",
  "dashboard.copyProjectPrompt": "Geben Sie einen neuen Titel ein (leer lassen für \"Originaltitel (Kopie)\"):",
  "dashboard.deleteConfirm": "\"{{title}}\" löschen? Diese Aktion kann nicht rückgängig gemacht werden.",
  "dashboard.statusUnknown": "Unbekannt",
  "dashboard.collaborators": "{{count}} Mitarbeiter",
  "dashboard.menu": "Menü",
  "dashboard.shareSettings": "Freigabe-Einstellungen",
  "dashboard.copy": "Kopieren",
  "dashboard.delete": "Löschen",
  "dashboard.subjects": "Objekte",
  "dashboard.criteria": "Kriterien",
  "dashboard.progress": "Fortschritt",
  "dashboard.completed": "Abgeschlossen",
  "dashboard.created": "Erstellt:",
  "dashboard.updated": "Aktualisiert:",
  "dashboard.loadingDashboard": "Dashboard wird geladen...",
  "dashboard.retry": "Wiederholen",
  "dashboard.title": "Bewertungs-Dashboard",
  "dashboard.projectMerge": "Projektintegration",
  "dashboard.createNew": "Neue Bewertung erstellen",
  "dashboard.inProgressTab": "Laufende Bewertungen",
  "dashboard.completedTab": "Abgeschlossene Bewertungen",
  "dashboard.noInProgress": "Keine laufenden Bewertungen",
  "dashboard.noInProgressDesc": "Lassen Sie uns mit der Erstellung einer neuen Bewertung beginnen.",
  "dashboard.noCompleted": "Keine abgeschlossenen Bewertungen",
  "dashboard.noCompletedDesc": "Abgeschlossene Bewertungen werden hier angezeigt.",
  "dashboard.untitledProject": "Unbenanntes Bewertungsprojekt",
  "dashboard.sharing": "Teilen",
  "billing.paymentCompleted": "Zahlung abgeschlossen",
  "billing.subscriptionCompleted": "Abonnementregistrierung abgeschlossen. Vielen Dank für die Nutzung unseres Services!",
  "billing.paymentCanceled": "Die Zahlung wurde abgebrochen. Bitte versuchen Sie es erneut oder kontaktieren Sie uns.",
  "settings.backToDashboard": "← Zurück zum Dashboard",
  "userSettings.title": "Benutzereinstellungen",
  "userSettings.description": "Verwalten Sie Ihre Kontoinformationen und Sicherheitseinstellungen.",
  "userSettings.basicInfo": "Grundlegende Informationen",
  "userSettings.username": "Benutzername",
  "userSettings.usernamePlaceholder": "Benutzername eingeben",
  "userSettings.email": "E-Mail-Adresse",
  "userSettings.emailPlaceholder": "beispiel@domain.com",
  "userSettings.displayName": "Anzeigename",
  "userSettings.displayNamePlaceholder": "Anzeigename eingeben (optional)",
  "userSettings.displayNameHelp": "Name, der anderen Benutzern angezeigt wird.",
  "userSettings.saving": "Speichern...",
  "userSettings.saveSettings": "Einstellungen speichern",
  "userSettings.securitySettings": "Sicherheitseinstellungen",
  "userSettings.securityMode": "Sicherheitsmodus",
  "userSettings.securityModeDescription": "Datenverschlüsselung aktivieren, um Ihre Privatsphäre zu schützen.",
  "userSettings.securityOn": "Aktiviert",
  "userSettings.securityOff": "Deaktiviert",
  "userSettings.securityCode": "Sicherheitscode",
  "userSettings.hide": "Verbergen",
  "userSettings.show": "Anzeigen",
  "userSettings.encryptionCode": "Verschlüsselungscode",
  "userSettings.recoveryCode": "Wiederherstellungscode",
  "userSettings.copy": "Kopieren",
  "userSettings.generateNewKeys": "Neue Schlüssel generieren",
  "userSettings.manualKeyInput": "Manuelle Schlüsseleingabe",
  "userSettings.viewSharedData": "Geteilte Daten anzeigen",
  "userSettings.viewSharedDataDescription": "Geben Sie Schlüssel ein, um verschlüsselte Daten anderer Benutzer anzuzeigen.",
  "userSettings.inputEncryptionKey": "Verschlüsselungsschlüssel eingeben",
  "userSettings.manualKeyTitle": "Manuelle Verschlüsselungsschlüssel-Eingabe",
  "userSettings.manualKeyDescription": "Geben Sie das geteilte Verschlüsselungsschlüsselpaar ein.",
  "userSettings.publicKey": "Öffentlicher Schlüssel",
  "userSettings.publicKeyPlaceholder": "Öffentlichen Schlüssel eingeben",
  "userSettings.privateKey": "Privater Schlüssel",
  "userSettings.privateKeyPlaceholder": "Privaten Schlüssel eingeben",
  "userSettings.keyWarning": "Warnung:",
  "userSettings.keyWarningText": "Diese Schlüssel sind vertraulich. Bewahren Sie sie an einem sicheren Ort auf.",
  "userSettings.setKeys": "Schlüssel festlegen",
  "userSettings.requiredFieldsError": "Benutzername und E-Mail-Adresse sind Pflichtfelder.",
  "userSettings.enableSecurityModeConfirm": "Sicherheitsmodus aktivieren? Die Datenverschlüsselung beginnt.",
  "userSettings.securityModeEnabled": "Der Sicherheitsmodus wurde aktiviert.",
  "userSettings.securityModeDisabled": "Der Sicherheitsmodus wurde deaktiviert.",
  "userSettings.generateNewKeysConfirm": "Neue Schlüssel generieren? Bestehende Schlüssel werden ungültig.",
  "userSettings.newKeysGenerated": "Neue Schlüssel wurden generiert.",
  "userSettings.bothKeysRequired": "Sowohl öffentlicher als auch privater Schlüssel sind erforderlich.",
  "userSettings.invalidPublicKeyFormat": "Format des öffentlichen Schlüssels ist ungültig.",
  "userSettings.invalidPrivateKeyFormat": "Format des privaten Schlüssels ist ungültig.",
  "userSettings.keysSet": "Schlüssel wurden festgelegt.",
  "userSettings.keySetError": "Fehler beim Festlegen der Schlüssel aufgetreten.",
  "userSettings.copiedToClipboard": "In die Zwischenablage kopiert.",
  "userSettings.copyFailed": "Kopieren fehlgeschlagen.",
  "billing.currentPlan": "Aktueller Plan",
  "billing.status.developerAccess": "Entwicklerzugang",
  "billing.status.active": "Aktiv",
  "billing.status.free": "Kostenlos",
  "billing.nextRenewalDate": "Nächstes Erneuerungsdatum",
  "billing.autoRenewalNote": "(wird automatisch belastet)",
  "billing.expiresAt": "Läuft ab am",
  "billing.cancelNotice": "Dieses Abonnement wird am Ende der aktuellen Periode gekündigt.",
  "billing.cancelSubscription": "Abonnement kündigen",
  "billing.cancelSubscriptionConfirm": "Abonnement kündigen? Es wird am Ende der aktuellen Periode gekündigt.",
  "billing.cancelSubscriptionSuccess": "Die Abonnementkündigung wurde bearbeitet. Es wird am Ende der aktuellen Periode gekündigt.",
  "billing.cancelSubscriptionFailed": "Kündigung fehlgeschlagen.",
  "billing.forIndividual": "(Für Privatpersonen)",
  "billing.forBusiness": "(Für Unternehmen)",
  "billing.forSchool": "(Für Schulen)",
  "billing.free": "Kostenlos",
  "billing.month": "Monat",
  "billing.year": "Jahr",
  "billing.features": "Funktionen",
  "billing.upgrade": "Upgraden",
  "billing.customQuote": "Individuelles Angebot",
  "billing.flexibleCustomization": "Flexible Anpassungsunterstützung",
  "billing.educationalDiscount": "Sonderpreise für Bildungseinrichtungen",
  "billing.requestCorporateQuote": "Unternehmensangebot anfragen",
  "billing.requestAcademicQuote": "Akademisches Angebot anfragen",
  "billing.aboutBilling": "Über die Abrechnung",
  "billing.autoRenewal": "Automatische Erneuerung",
  "billing.autoRenewalDescription": "Monatspläne werden automatisch am gleichen Tag jeden Monats erneuert",
  "billing.nextRenewalDateDescription": "Aktuelle Abonnenten können im Abschnitt \"Aktueller Plan\" oben nachsehen",
  "billing.cancellation": "Kündigung",
  "billing.cancellationDescription": "Kann jederzeit gekündigt werden, Service endet am Ende der aktuellen Periode",
  "billing.payment": "Zahlung",
  "billing.paymentDescription": "Wir verwenden das sichere Zahlungssystem von Stripe",
  "billing.receipt": "Quittung",
  "billing.receiptDescription": "Wird nach Zahlungsabschluss automatisch per E-Mail versandt",
  "billing.aiUsageLimitation": "KI-Nutzungsbeschränkungshinweis",
  "billing.enterprise": "Für Unternehmen",
  "billing.education": "Für Bildung",
  "billing.feature.limited_projects": "Bis zu 3 Projekte",
  "billing.feature.unlimited_projects": "Unbegrenzte Projekte",
  "billing.feature.unlimited_collaborators": "Unbegrenzte Mitarbeiter",
  "billing.feature.basic_rubric": "Grundlegende Bewertungsfunktionen",
  "billing.feature.advanced_rubric": "Erweiterte Bewertungsfunktionen",
  "billing.feature.ai_assistance": "KI-Unterstützungsfunktionen",
  "billing.feature.priority_support": "Prioritäts-Support",
  "billing.feature.data_export": "Datenexport",
  "billing.feature.custom_templates": "Benutzerdefinierte Vorlagen",
  "billing.feature.pdf_export": "PDF-Export",
  "billing.feature.limited_pdf_export": "PDF-Export (5 pro Tag)",
  "billing.feature.no_csv_export": "CSV-Export: Nicht verfügbar",
  "billing.feature.allProfessionalFeatures": "Alle Professional Plan Funktionen",
  "billing.feature.unlimitedUsers": "Unbegrenzte Benutzeranzahl",
  "billing.feature.dedicatedSupportAgent": "Dedizierter Support-Agent",
  "billing.feature.customIntegrationAPI": "Benutzerdefinierte Integration & API-Entwicklung",
  "billing.feature.customBranding": "Benutzerdefinierte Branding-Unterstützung",
  "billing.feature.singleSignOn": "Single Sign-On (SSO)",
  "billing.feature.auditLogSecurity": "Audit-Log & Sicherheitsfunktionen",
  "billing.feature.onPremiseDeployment": "On-Premise-Bereitstellungsunterstützung",
  "billing.feature.trainingImplementationSupport": "Schulungs- & Implementierungsunterstützung",
  "billing.feature.unlimitedStudentFacultyAccounts": "Unbegrenzte Studenten- & Fakultätskonten",
  "billing.feature.educationalInstitutionSpecialPricing": "Sonderpreise für Bildungseinrichtungen",
  "billing.feature.classroomPracticalTemplates": "Klassen- & Praxisvorlagen",
  "billing.feature.gradeManagementSystemIntegration": "Notenverwaltungssystem-Integration",
  "billing.feature.learningAnalyticsReporting": "Lernanalyse & Berichterstattung",
  "billing.feature.parentGuardianSharingFeature": "Eltern- & Erziehungsberechtigten-Freigabefunktion",
  "billing.feature.educationalInstitutionDedicatedSupport": "Dedizierter Support für Bildungseinrichtungen",
  "billing.feature.implementationTrainingTeacherTraining": "Implementierungsschulung & Lehrerfortbildung",
  "quote.title": "Enterprise Plan Kostenvoranschlag",
  "quote.submit": "Kostenvoranschlag anfordern",
  "quote.sections.contactInfo": "Kontaktinformationen",
  "quote.sections.usagePlan": "Nutzungsplan",
  "quote.sections.budgetRequirements": "Budget & Anforderungen",
  "quote.fields.name": "Name",
  "quote.fields.position": "Position",
  "quote.fields.phone": "Telefonnummer",
  "quote.fields.expectedUsers": "Erwartete Benutzeranzahl",
  "quote.fields.timeline": "Implementierungszeitplan",
  "quote.fields.useCase": "Anwendungsfall",
  "quote.fields.currentSolution": "Aktuelle Bewertungsmethode/Tool",
  "quote.fields.budget": "Budgetbereich",
  "quote.fields.requirements": "Erforderliche Funktionen/Anforderungen",
  "quote.fields.message": "Zusätzliche Anfragen/Fragen",
  "quote.placeholders.currentSolution": "Bitte beschreiben Sie aktuelle Bewertungsmethoden oder Tools, die Sie verwenden",
  "quote.placeholders.message": "Bitte lassen Sie uns wissen, wenn Sie zusätzliche Anfragen oder Fragen haben",
  "quote.timeline.immediate": "Sofort",
  "quote.timeline.oneMonth": "Innerhalb 1 Monat",
  "quote.timeline.threeMonths": "Innerhalb 3 Monate",
  "quote.timeline.sixMonths": "Innerhalb 6 Monate",
  "quote.timeline.oneYear": "Innerhalb 1 Jahr",
  "quote.timeline.undecided": "Unentschieden",
  "quote.success.title": "Kostenvoranschlag-Anfrage erhalten",
  "quote.error.submitFailed": "Fehler beim Senden der Kostenvoranschlag-Anfrage",
  "quote.error.submitFailedRetry": "Fehler beim Senden der Kostenvoranschlag-Anfrage. Bitte versuchen Sie es später erneut.",
  "common.pleaseSelect": "Bitte wählen",
  "common.other": "Andere",
  "common.submitting": "Senden...",
  "quote.corporate.subtitle": "Für Unternehmen",
  "quote.corporate.description": "Wir bieten anpassbare Unternehmenslösungen, die auf die Bedürfnisse Ihres Unternehmens zugeschnitten sind. Bitte füllen Sie das untenstehende Formular aus und kontaktieren Sie uns gerne.",
  "quote.corporate.sections.companyInfo": "Unternehmensinformationen",
  "quote.corporate.fields.companyName": "Firmenname",
  "quote.corporate.fields.department": "Abteilung",
  "quote.corporate.userCounts.small": "10-50 Benutzer",
  "quote.corporate.userCounts.medium": "51-100 Benutzer",
  "quote.corporate.userCounts.large": "101-300 Benutzer",
  "quote.corporate.userCounts.xlarge": "301-500 Benutzer",
  "quote.corporate.userCounts.xxlarge": "501-1.000 Benutzer",
  "quote.corporate.userCounts.enterprise": "1.000+ Benutzer",
  "quote.corporate.budget.under500k": "Unter 5.000 €/Monat",
  "quote.corporate.budget.500k1m": "5.000-10.000 €/Monat",
  "quote.corporate.budget.1m3m": "10.000-30.000 €/Monat",
  "quote.corporate.budget.3m5m": "30.000-50.000 €/Monat",
  "quote.corporate.budget.over5m": "Über 50.000 €/Monat",
  "quote.corporate.placeholders.useCase": "z.B.: internes Bewertungssystem, Bewertung von Bewerbungsinterviews, Messung der Trainingseffektivität",
  "quote.corporate.formNote": "Die von Ihnen bereitgestellten Informationen werden gemäß unserer Datenschutzrichtlinie angemessen verwaltet.",
  "quote.success.corporate.message": "Vielen Dank für Ihre Anfrage. Unser Vertreter wird Sie innerhalb von 2 Geschäftstagen kontaktieren.",
  "quote.corporate.requirements.sso": "Single Sign-On (SSO)",
  "quote.corporate.requirements.activeDirectory": "Active Directory Integration",
  "quote.corporate.requirements.customBranding": "Individuelles Branding",
  "quote.corporate.requirements.dedicatedServer": "Dedizierter Server/On-Premise-Bereitstellung",
  "quote.corporate.requirements.apiIntegration": "API-Integration/Benutzerdefinierte Integration",
  "quote.corporate.requirements.auditLogs": "Audit-Logs/Sicherheitsfunktionen",
  "quote.corporate.requirements.multilingual": "Mehrsprachige Unterstützung",
  "quote.corporate.requirements.support24": "24/7 Support",
  "quote.corporate.requirements.training": "Implementierungsschulung",
  "quote.corporate.requirements.dataMigration": "Datenmigrations-Support",
  "quote.academic.subtitle": "Für Schulen & Bildungseinrichtungen",
  "quote.academic.description": "Wir bieten speziell auf Bildungseinrichtungen zugeschnittene Lösungen. Sonderpreise und bildungsspezifische Funktionsanpassungen sind verfügbar.",
  "quote.academic.sections.institutionInfo": "Bildungseinrichtungs-Informationen",
  "quote.academic.fields.institutionName": "Schul-/Einrichtungsname",
  "quote.academic.fields.institutionType": "Einrichtungstyp",
  "quote.academic.fields.department": "Fakultät/Abteilung",
  "quote.academic.fields.positionTitle": "Position/Titel",
  "quote.academic.fields.expectedUsers": "Erwartete Benutzeranzahl (Lehrpersonal)",
  "quote.academic.fields.studentCount": "Schüleranzahl",
  "quote.academic.fields.currentSolution": "Aktuelle Bewertungsmethode/System",
  "quote.academic.fields.budgetAnnual": "Budgetbereich (Jährlich)",
  "quote.academic.institutionTypes.university": "Universität",
  "quote.academic.institutionTypes.college": "Hochschule/Fachhochschule",
  "quote.academic.institutionTypes.highSchool": "Gymnasium",
  "quote.academic.institutionTypes.juniorHigh": "Realschule",
  "quote.academic.institutionTypes.elementary": "Grundschule",
  "quote.academic.institutionTypes.vocational": "Berufsschule",
  "quote.academic.userCounts.small": "5-20 Benutzer",
  "quote.academic.userCounts.medium": "21-50 Benutzer",
  "quote.academic.userCounts.large": "51-100 Benutzer",
  "quote.academic.userCounts.xlarge": "101-300 Benutzer",
  "quote.academic.userCounts.xxlarge": "301-500 Benutzer",
  "quote.academic.userCounts.enterprise": "500+ Benutzer",
  "quote.academic.studentCounts.under100": "Unter 100",
  "quote.academic.studentCounts.small": "100-500",
  "quote.academic.studentCounts.medium": "501-1.000",
  "quote.academic.studentCounts.large": "1.001-3.000",
  "quote.academic.studentCounts.xlarge": "3.001-10.000",
  "quote.academic.studentCounts.xxlarge": "10.000+",
  "quote.academic.timeline.nextSemester": "Nächstes Semester",
  "quote.academic.timeline.nextYear": "Nächstes Schuljahr",
  "quote.academic.budget.under1m": "Unter 10.000 €",
  "quote.academic.budget.1m3m": "10.000-30.000 €",
  "quote.academic.budget.3m5m": "30.000-50.000 €",
  "quote.academic.budget.5m10m": "50.000-100.000 €",
  "quote.academic.budget.over10m": "100.000 €+",
  "quote.academic.placeholders.position": "z.B.: Professor, Dozent, Verwaltungspersonal",
  "quote.academic.placeholders.useCase": "z.B.: Schülerbewertung, praktische/Fähigkeiten-Bewertung, Lehrerfortbildung, Kursbewertung",
  "quote.academic.placeholders.currentSolution": "Bitte beschreiben Sie aktuelle Bewertungsmethoden oder Systeme, die Sie verwenden",
  "quote.academic.placeholders.message": "Bitte lassen Sie uns wissen, wenn Sie spezifische Anforderungen für Bildungseinrichtungen oder Fragen haben",
  "quote.academic.formNote": "Die von Ihnen bereitgestellten Informationen werden gemäß unserer Datenschutzrichtlinie angemessen verwaltet.",
  "quote.success.academic.message": "Vielen Dank für Ihre Anfrage. Unser Spezialist für Bildungseinrichtungen wird Sie innerhalb von 2 Geschäftstagen kontaktieren.",
  "quote.academic.requirements.lmsIntegration": "Learning Management System (LMS) Integration",
  "quote.academic.requirements.gradeManagement": "Notenverwaltungssystem-Integration",
  "quote.academic.requirements.studentPortal": "Studenten-Portal Integration",
  "quote.academic.requirements.parentSharing": "Eltern-/Erziehungsberechtigten-Freigabe",
  "quote.academic.requirements.courseTemplates": "Kurs-/Praxis-Vorlagen",
  "quote.academic.requirements.learningAnalytics": "Lernanalyse/Berichterstattung",
  "quote.academic.requirements.multilingualEng": "Mehrsprachige Unterstützung (Englisch, etc.)",
  "quote.academic.requirements.teacherTraining": "Lehrerfortbildung",
  "quote.academic.requirements.implementationSupport": "Implementierungs-Support/Schulung",
  "common.backToDashboard": "Zurück zum Dashboard",

  // Report Generation
  "report.title": "Berichtserstellung",
  "report.evaluationNotice": "Bewertungsbericht",
  "report.evaluationDate": "Bewertungsdatum",
  "report.criteriaEvaluation": "Kriterienbasierte Bewertung",
  "report.overallEvaluation": "Gesamtbewertung",
  "report.comments": "Kommentare",
  "report.commentsPlaceholder": "Details oder Kommentare eingeben...",
  "report.commentsEmpty": "Keine Details eingegeben",
  "report.editComments": "Details bearbeiten",
  "report.showPreview": "Vorschau anzeigen",
  "report.hidePreview": "Vorschau ausblenden",
  "report.preview": "Vorschau",
  "report.criterionColumn": "Kriterium",
  "report.gradeColumn": "Note",
  "report.rankColumn": "Rang",
  "report.descriptionColumn": "Beschreibung",
  "report.nthGrade": "Note {{grade}}",
  "report.topPercentile": "Top {{percent}}%",
  "report.rankFormat": "{{position}}/{{total}}",
  "report.noDescription": "-",
  "report.personalEvaluation": "Persönliche Bewertung",
  "report.groupAverage": "Gruppendurchschnitt",
  "report.summary": "Zusammenfassung",
  "report.enableOverallEvaluation": "Gesamtbewertung aktivieren",
  "report.disableOverallEvaluation": "Gesamtbewertung deaktivieren",
  "report.pointsFormat": "{{score}} Punkte / {{maxScore}} Punkte",
  "report.percentageFormat": "({{percentage}}%)",
  "report.configureWeights": "Gewichtungen konfigurieren",
  "report.footerNote": "※ Diese Bewertung zeigt sowohl kriterienbasierte als auch normbasierte Bewertungen.",
  "report.rubricTitle": "Bewertungskriterien (Rubrik)",
  "report.noRubric": "Es wurde keine Rubrik erstellt",
  "report.noSubjects": "Es wurden keine Bewertungsthemen registriert.",
  "report.print": "Drucken",
  "report.downloadPdf": "PDF herunterladen",
  "report.downloadPdfLimitReached": "PDF herunterladen (Limit erreicht)",
  "report.pdfExportLimit": "PDF-Export-Limit ({{count}} Dateien pro Tag) erreicht. Bitte upgraden Sie auf {{planName}} oder versuchen Sie es morgen erneut.",
  "report.pdfExportError": "PDF-Export ist nicht verfügbar.",
  "report.pdfGenerationFailed": "PDF-Generierung fehlgeschlagen.",
  "report.pdfGenerationError": "PDF-Generierungsfehler:",
  "report.reportCardNotFound": "Zeugnis nicht gefunden.",
  "report.pdfExportStatus": "Heutige PDF-Exporte: {{current}}/{{max}}",
  "report.pdfExportRemaining": " ({{remaining}} verbleibend)",
  "report.pdfExportLimitReached": "Tägliches Export-Limit erreicht. {{planName}} bietet unbegrenzte Exporte.",
  "report.backToRubric": "Zurück zur Rubrik-Erstellung",
  "autoSave.unsaved": "Nicht gespeichert",
  "autoSave.savedSecondsAgo": "Vor {{seconds}} Sekunden gespeichert",
  "autoSave.savedMinutesAgo": "Vor {{minutes}} Minuten gespeichert",
  "autoSave.savedAtTime": "Um {{time}} gespeichert",
  "autoSave.saving": "Speichern...",
  "autoSave.unsavedChanges": "Nicht gespeicherte Änderungen",
  "autoSave.autoSaveOn": "Automatisches Speichern: EIN",
  "plan.pro": "PRO",
  "billing.businessPrice": "€25~",
  "billing.schoolPrice": "€7~",
  "billing.pricePerMonth": "/Monat/Person",

  // Steps
  "steps.process.ariaLabel": "Bewertungsprozess",
  "steps.productRegistration.title": "Objekte registrieren",
  "steps.productRegistration.description": "Zu bewertende Objekte registrieren",
  "steps.criteriaExtraction.title": "Kriterien extrahieren",
  "steps.criteriaExtraction.description": "Bewertungskriterien mit KI extrahieren",
  "steps.comparison.title": "Vergleichende Bewertung",
  "steps.comparison.description": "Relativ positionieren",
  "steps.gradeAssignment.title": "Notenvergabe",
  "steps.gradeAssignment.description": "Endnoten festlegen",
  "steps.rubricGeneration.title": "Rubrik erstellen",
  "steps.rubricGeneration.description": "Rubrik mit KI erstellen",
  "steps.quickEvaluation.title": "Schnellbewertung",
  "steps.quickEvaluation.description": "Bewertung einfach abschließen",
  "steps.reportGeneration.title": "Berichte erstellen",
  "steps.reportGeneration.description": "Schöne Zeugnisse generieren",

  // Criteria Extraction
  "criteriaExtraction.emptyState.title": "Bitte registrieren Sie zuerst Bewertungsobjekte",
  "criteriaExtraction.emptyState.description": "Um Kriterien zu extrahieren, müssen Sie zuerst Bewertungsobjekte registrieren.",
  "criteriaExtraction.emptyState.backButton": "Zurück zur Objektregistrierung",
  "criteriaExtraction.title": "Kriterienextraktion",
  "criteriaExtraction.description": "Beschreiben Sie, welche Kriterien Sie bewerten möchten. KI wird automatisch Bewertungskriterien extrahieren.",
  "criteriaExtraction.policyTitle": "Bewertungsrichtlinie & Schwerpunkte",
  "criteriaExtraction.policyDescription": "Beschreiben Sie spezifisch, welche Kriterien Sie bewerten möchten. KI wird automatisch optimale Bewertungskriterien extrahieren.",
  "criteriaExtraction.policyLabel": "Bewertungsrichtlinie",
  "criteriaExtraction.policyPlaceholder": "Beispiel: Logische Struktur betonen, Kreativität und Originalität bewerten, Machbarkeit fokussieren, usw.",
  "criteriaExtraction.removePolicyTitle": "Bewertungsrichtlinie {{index}} entfernen",
  "criteriaExtraction.addPolicyButton": "Bewertungsrichtlinie hinzufügen",
  "criteriaExtraction.extractButton": "Mit KI extrahieren",
  "criteriaExtraction.extractingButton": "Extrahiere mit KI...",
  "criteriaExtraction.extractedTitle": "Extrahierte Bewertungskriterien",
  "criteriaExtraction.extractedSubtitle": "{{count}} Bewertungskriterien wurden extrahiert. Bitte überprüfen und bearbeiten Sie den Inhalt.",
  "criteriaExtraction.addCriterionButton": "Kriterium manuell hinzufügen",
  "criteriaExtraction.newCriterionTitle": "Neues Kriterium",
  "criteriaExtraction.newCriterionDescription": "Bewerten Sie basierend auf diesem Kriterium",
  "criteriaExtraction.successTitle": "Kriterienextraktion abgeschlossen!",
  "criteriaExtraction.successDescription": "Überprüfen Sie jedes Kriterium und bearbeiten Sie es bei Bedarf, bevor Sie zum nächsten Schritt fortfahren.",
  "criteriaExtraction.nextButton": "Zur Vergleichsbewertung",
  "criteriaExtraction.prevButton": "Zurück zur Objektregistrierung",

  // Product Registration
  "productRegistration.title": "Bewertungsobjekte registrieren",
  "productRegistration.description": "Registrieren Sie zu bewertende Objekte (Studentenberichte, Produkte, Vorschläge usw.).",
  "productRegistration.securityNotice": "🔒 Sicherheitsmodus ist aktiviert. Objektnamen werden verschlüsselt.",
  "productRegistration.viewToggle.form": "Formular",
  "productRegistration.viewToggle.formTitle": "Formularansicht",
  "productRegistration.viewToggle.table": "Tabelle",
  "productRegistration.viewToggle.tableTitle": "Tabellenansicht",
  "productRegistration.import.drive": "Aus Google Drive importieren",
  "productRegistration.import.driveTitle": "Aus Google Drive importieren",
  "productRegistration.import.driveLabel": "Aus Google Drive importieren",
  "productRegistration.import.csv": "CSV-Datei hochladen",
  "productRegistration.import.csvTitle": "CSV-Datei hochladen",
  "productRegistration.import.csvLabel": "CSV-Datei hochladen",
  "productRegistration.import.template": "CSV-Vorlage herunterladen",
  "productRegistration.import.templateTitle": "CSV-Vorlage herunterladen",
  "productRegistration.import.templateLabel": "CSV-Vorlage herunterladen",
  "productRegistration.import.driveDetail": "Aus Google Drive importiert: {{fileName}}",
  "productRegistration.form.titleLabel": "Objektname",
  "productRegistration.form.titlePlaceholder": "z.B. Bericht A, Vorschlag B, Projekt C",
  "productRegistration.form.titleHelp": "Geben Sie den Namen des zu bewertenden Objekts ein",
  "productRegistration.form.linkLabel": "Link (Optional)",
  "productRegistration.form.linkPlaceholder": "https://drive.google.com/... usw.",
  "productRegistration.form.linkHelp": "Geben Sie die URL für zugehörige Materialien oder Dateien ein, falls verfügbar",
  "productRegistration.form.detailLabel": "Details & Kommentare",
  "productRegistration.form.detailPlaceholder": "Geben Sie Details ein, die für die Bewertung notwendig sind, wie Eigenschaften, Inhalt und Hintergrundinformationen.\nBeispiel: \"Entwurf der Abschlussarbeit, Vorschlag zur regionalen Revitalisierung erstellt von einem Wirtschaftsstudenten im 3. Jahr\"",
  "productRegistration.form.detailHelp": "Bitte geben Sie spezifische Details über Inhalt und Eigenschaften an, um Bewertern bei der ordnungsgemäßen Bewertung zu helfen",
  "productRegistration.form.addButton": "Objekt hinzufügen",
  "productRegistration.list.title": "Registrierte Objekte ({{count}})",
  "productRegistration.list.encryptedBadge": "🔒 Verschlüsselt",
  "productRegistration.list.encrypted": "Verschlüsselt",
  "productRegistration.edit.titlePlaceholder": "Objektname eingeben",
  "productRegistration.edit.linkPlaceholder": "Link-URL eingeben",
  "productRegistration.edit.detailPlaceholder": "Details & Kommentare eingeben",
  "productRegistration.edit.save": "Speichern",
  "productRegistration.edit.cancel": "Abbrechen",
  "productRegistration.preview": "{{title}} Vorschau",
  "productRegistration.edit": "{{title}} bearbeiten",
  "productRegistration.delete": "{{title}} löschen",
  "productRegistration.googleDrive.importedDetail": "Aus Google Drive importiert: {{name}}",
  "productRegistration.csv.header1": "Objektname",
  "productRegistration.csv.detail1": "Detaillierte Beschreibung",
  "productRegistration.csv.validationError": "CSV-Datei muss die Spalten reviewTitle und reviewComment haben. Bitte laden Sie die Vorlage herunter und überprüfen Sie.",
  "productRegistration.error.encryptionFailed": "Objektname konnte nicht verschlüsselt werden. Bitte überprüfen Sie die Sicherheitseinstellungen.",
  "productRegistration.navigation.next": "Zur Kriterienextraktion",
  "productRegistration.directRubric.title": "Rubrik direkt erstellen",
  "productRegistration.directRubric.description": "Sie können auch die Kriterienextraktion überspringen und eine Rubrik manuell erstellen.",
  "productRegistration.directRubric.button": "Zur manuellen Rubrikerstellung",
  "productRegistration.nextButton": "Zur Kriterienextraktion",
  "productRegistration.error.decryptionLog": "Entschlüsselungsfehler für Objekt {{index}}:",
  "productRegistration.error.decryptionDisplay": "[Entschlüsselungsfehler]",
  "productRegistration.error.encryptionLog": "Objektnamen-Verschlüsselungsfehler:",
  "productRegistration.error.encryptionAlert": "Objektname konnte nicht verschlüsselt werden. Bitte überprüfen Sie die Sicherheitseinstellungen.",
  "productRegistration.error.csvAlert": "CSV-Datei muss die Spalten reviewTitle und reviewComment haben. Bitte laden Sie die Vorlage herunter und überprüfen Sie.",
  "productRegistration.csv.exampleTitle1": "Objektname 1",
  "productRegistration.csv.exampleDetail1": "Detaillierte Beschreibung 1",
  "productRegistration.csv.exampleTitle2": "Objektname 2",
  "productRegistration.csv.exampleDetail2": "Detaillierte Beschreibung 2",
  "productRegistration.csv.exampleTitle3": "Objektname 3",
  "productRegistration.csv.exampleDetail3": "Detaillierte Beschreibung 3",

  // Comparison Evaluation
  "comparisonEvaluation.emptyState.title": "Bitte legen Sie zuerst Bewertungsobjekte und Kriterien fest",
  "comparisonEvaluation.emptyState.description": "Sowohl Bewertungsobjekte als auch Kriterien werden für die vergleichende Bewertung benötigt.",
  "comparisonEvaluation.emptyState.backToProducts": "Zurück zur Objektregistrierung",
  "comparisonEvaluation.emptyState.backToCriteria": "Zurück zur Kriterienextraktion",
  "comparisonEvaluation.title": "Ordnen wir einige nach Qualität",
  "comparisonEvaluation.description": "",
  "comparisonEvaluation.criterionSelector.title": "Bewertungskriterium auswählen",
  "comparisonEvaluation.productsPanel.title": "Bewertungsobjekte",
  "comparisonEvaluation.productsPanel.hint": "Ziehen Sie zur Positionierung auf der Zahlenlinie",
  "comparisonEvaluation.evaluationLine.low": "Schlecht",
  "comparisonEvaluation.evaluationLine.high": "Gut",
  "comparisonEvaluation.evaluationLine.hint": "Sie können platzierte Elemente ziehen und neu positionieren",
  "comparisonEvaluation.progress.prefix": "Fortschritt: ",
  "comparisonEvaluation.progress.suffix": " / {{total}} platziert",
  "comparisonEvaluation.progress.completed": "✅ Alle Bewertungen abgeschlossen",
  "comparisonEvaluation.options.title": "Platzierungsmethode auswählen",
  "comparisonEvaluation.options.description": "Sie können wählen, ob Sie alle Elemente auf einmal platzieren oder den Schnellmodus verwenden, um sie nach der Rubrikerstellung einzeln zu platzieren.",
  "comparisonEvaluation.options.quickModeButton": "Schnellbewertungsmodus verwenden",
  "comparisonEvaluation.options.quickModeNote": "※ Einfacher Modus zum einzelnen Platzieren nach der Rubrikerstellung",
  "comparisonEvaluation.nextButton": "Zur Notenvergabe",
  "comparisonEvaluation.prevButton": "Zurück zur Kriterienextraktion",

  // Grade Assignment
  "gradeAssignment.emptyState.title": "Bitte schließen Sie die Bewertung ab",
  "gradeAssignment.emptyState.description": "Die vergleichende Bewertung muss abgeschlossen sein, um Noten festzulegen.",
  "gradeAssignment.emptyState.backButton": "Zurück zur vergleichenden Bewertung",
  "gradeAssignment.title": "Notenvergabe",
  "gradeAssignment.description": "Ziehen Sie für jedes Kriterium die Notengrenzen, um sie anzupassen.",
  "gradeAssignment.criterionSelector.title": "Kriterium auswählen",
  "gradeAssignment.gradeSuffix": "Noten",
  "gradeAssignment.gradeSettings.titleSuffix": " Noteneinstellungen",
  "gradeAssignment.editGradesButton": "Noten bearbeiten",
  "gradeAssignment.boundaries.title": "Notengrenzenanpassung",
  "gradeAssignment.boundaries.description": "Ziehen Sie die Grenzlinien, um Notenbereiche anzupassen",
  "gradeAssignment.distribution.title": "Notenverteilung",
  "gradeAssignment.table.grade": "Note",
  "gradeAssignment.table.count": "Anzahl",
  "gradeAssignment.table.percentage": "Prozent",
  "gradeAssignment.table.subjects": "Bewertungsobjekte",
  "gradeAssignment.table.tooltip": "Doppelklicken für Details",
  "gradeAssignment.nextButton": "Zur Rubrikgenerierung",
  "gradeAssignment.prevButton": "Zurück zur vergleichenden Bewertung",
  "gradeAssignment.modal.title": "Noten bearbeiten",
  "gradeAssignment.modal.gradeNamesTitle": "Notennamen festlegen",
  "gradeAssignment.modal.gradeLabel": "Note {{index}}",
  "gradeAssignment.modal.deleteButton": "Löschen",
  "gradeAssignment.modal.addGradeButton": "Note hinzufügen",
  "gradeAssignment.modal.doneButton": "Fertig",
  "gradeAssignment.status.notEvaluated": "Nicht bewertet",
  "gradeAssignment.status.notSet": "Nicht festgelegt",
  "gradeAssignment.saveSuccess": "Bewertungsdaten gespeichert!",
  "rubricGeneration.emptyState.title": "Bitte schließen Sie die Notenzuweisung ab",
  "rubricGeneration.emptyState.description": "Die Notenzuweisung muss abgeschlossen sein, bevor Bewertungsraster erstellt werden können.",
  "rubricGeneration.emptyState.backButton": "Zurück zur Notenzuweisung",
  "rubricGeneration.title": "Bewertungsraster-Erstellung",
  "rubricGeneration.description": "Erstellen Sie detaillierte Bewertungsraster durch Analyse der Unterschiede zwischen erstklassigen Arbeiten.",
  "rubricGeneration.progress.title": "Fortschritt der Notengrenz-Differenzanalyse",
  "rubricGeneration.progress.criteriaComplete": "Kriterien abgeschlossen",
  "rubricGeneration.progress.boundaryComplete": "Grenzen abgeschlossen",
  "rubricGeneration.question.criterionLabel": "Kriterium:",
  "rubricGeneration.question.gradeSuffix": "Note",
  "rubricGeneration.question.moreCount": "+{{count}} weitere",
  "rubricGeneration.question.title": "Welche Unterschiede haben Sie zwischen Note {{upperGrade}} und Note {{lowerGrade}} für das Kriterium \"{{criterion}}\" bemerkt?",
  "rubricGeneration.question.placeholder": "Beispiel: Arbeiten der Note {{upperGrade}} haben eine klare logische Struktur mit reichlich unterstützenden Daten. Arbeiten der Note {{lowerGrade}} haben gute Argumente, aber es fehlen spezifische Beispiele und Überzeugungskraft.",
  "rubricGeneration.question.addButton": "Unterschied hinzufügen",
  "rubricGeneration.question.recordedDifferences": "Erfasste Unterschiede:",
  "rubricGeneration.question.deleteButton": "Löschen",
  "rubricGeneration.question.completeButton": "Diese Grenzanalyse abschließen",
  "rubricGeneration.summary.title": "Zusammenfassung der Notengrenz-Analyse",
  "rubricGeneration.summary.boundaryTitle": "Grenze {{upperGrade}}-{{lowerGrade}}",
  "rubricGeneration.summary.differencesCount": "{{count}} Unterschiede erfasst",
  "rubricGeneration.generation.generating": "Bewertungsraster wird erstellt...",
  "rubricGeneration.generation.generateButton": "KI-Bewertungsraster erstellen",
  "rubricGeneration.display.title": "Erstelltes Bewertungsraster",
  "rubricGeneration.display.description": "Detailliertes Bewertungsraster, erstellt aus KI-analysierten Unterschiedsinformationen.",
  "rubricGeneration.display.regenerateButton": "Neu generieren",
  "rubricGeneration.navigation.nextToQuick": "Zur Schnellbewertung",
  "rubricGeneration.navigation.backToGrade": "Zurück zur Notenzuweisung",
  "rubricGeneration.error.generation": "Beim Erstellen des Bewertungsrasters ist ein Fehler aufgetreten",

  // Progress Bar
  "progressBar.label": "Bewertungsfortschritt",
  "progressBar.messages.criteriaSetup": "Das Festlegen von Kriterien schließt 15% ab",
  "progressBar.messages.completed": "🎉 Bewertung abgeschlossen!",
  "progressBar.messages.progress": "Produkte: {{products}} × Kriterien: {{criteria}} = {{total}} Bewertungen",

  // Evaluation Header
  "evaluationHeader.placeholder": "Bewertungstitel eingeben",
  "evaluationHeader.saveTitle": "Speichern",
  "evaluationHeader.cancelTitle": "Abbrechen",
  "evaluationHeader.untitled": "Unbenannte Bewertung",
  "evaluationHeader.editTitle": "Titel bearbeiten",

  // Draggable Product Card
  "draggableProductCard.detailsCount": "Details: {{count}} Zeichen",
  "draggableProductCard.previewAvailable": "🔗 Vorschau verfügbar",
  "draggableProductCard.showPreview": "Vorschau anzeigen",
  "draggableProductCard.editDetails": "Details bearbeiten",
  "draggableProductCard.position": "Position: {{value}}",
  "draggableProductCard.rank": "Rang: {{value}}",
  "draggableProductCard.placed": "Platziert",

  // Comparative Evaluation Quick
  "comparativeEvaluationQuick.title": "Schneller Bewertungsmodus",
  "comparativeEvaluationQuick.criterionSelector.title": "Bewertungskriterium auswählen",
  "comparativeEvaluationQuick.productsPanel.title": "Bewertungselemente",
  "comparativeEvaluationQuick.productsPanel.currentlyEvaluating": "Aktuell in Bewertung:",
  "comparativeEvaluationQuick.nextButton": "Weiter",
  "comparativeEvaluationQuick.prevButton": "Zurück",
  "comparativeEvaluationQuick.grades.excellent": "Ausgezeichnet",
  "comparativeEvaluationQuick.grades.good": "Gut",
  "comparativeEvaluationQuick.grades.average": "Durchschnittlich",
  "comparativeEvaluationQuick.grades.needsImprovement": "Verbesserungsbedürftig",
  "comparativeEvaluationQuick.completion.title": "Bewertung abgeschlossen",
  "comparativeEvaluationQuick.completion.subtitle": "Alle {{count}} Elemente wurden bewertet",
  "comparativeEvaluationQuick.completion.evaluationCount": "Bewertete Elemente",
  "comparativeEvaluationQuick.completion.criteriaCount": "Bewertungskriterien",
  "comparativeEvaluationQuick.completion.viewResults": "Ergebnisse anzeigen",
  "comparativeEvaluationQuick.completion.detailAdjustment": "Detailanpassung",
  "comparativeEvaluationQuick.criterionComplete.title": "\"{{criterion}}\" abgeschlossen",
  "comparativeEvaluationQuick.criterionComplete.subtitle": "{{count}} Elemente bewertet",
  "comparativeEvaluationQuick.criterionComplete.nextCriterion": "Nächstes Kriterium: ",
  "comparativeEvaluationQuick.criterionComplete.proceedToNext": "Zum nächsten Kriterium",
  "comparativeEvaluationQuick.criterionComplete.allComplete": "Alle Kriterienbewertungen sind abgeschlossen",
  "comparativeEvaluationQuick.criterionComplete.viewResults": "Ergebnisse anzeigen",
  "comparativeEvaluationQuick.empty.title": "Keine Daten zur Bewertung",
  "comparativeEvaluationQuick.empty.description": "Bitte richten Sie Produkte und Bewertungskriterien ein.",
  "comparativeEvaluationQuick.header.doubleClickToView": "Doppelklick für Details",
  "comparativeEvaluationQuick.header.progress": "{{completed}} / {{total}} abgeschlossen",
  "comparativeEvaluationQuick.header.criterionProgress": "({{current}} / {{total}} Kriterien)",
  "comparativeEvaluationQuick.navigation.nextCriterion": "Nächstes Kriterium: {{name}}",
  "comparativeEvaluationQuick.progress.remaining": "{{count}} verbleibend",
  "comparativeEvaluationQuick.gradeExplanation.instruction": "Klicken Sie irgendwo von links (D: Verbesserungsbedürftig) nach rechts (A: Ausgezeichnet), um Ihre Bewertung zu platzieren.",
  "comparativeEvaluationQuick.gradeExplanation.currentPosition": " Aktuelle Position: {{grade}} ({{description}})",
  "comparativeEvaluationQuick.actions.switchToAllMode": "Zu Alle-Platzierungsmodus wechseln",
  "comparativeEvaluationQuick.shortcuts.enterNext": "Enter drücken für nächstes Kriterium",
  "comparativeEvaluationQuick.shortcuts.spaceSkip": "Leertaste drücken zum Überspringen",
  "comparativeEvaluationQuick.criterion.instruction": "Beurteilen Sie die Überlegenheit in diesem Kriterium",

  // Grade Assignment
  "gradeAssignment.modal.gradePlaceholder": "Notennamen eingeben",
  "gradeAssignment.boundaryLabel": "{{upper}}・{{lower}} Grenze",
  "gradeAssignment.doubleClickToView": "Doppelklick für Details",
  "gradeAssignment.dragBoundaryHint": "Ziehen Sie die Grenzlinien, um die Notenbereiche anzupassen",
  "gradeAssignment.percentAbove": "{{percent}}% oder mehr ist {{grade}}",
  "gradeAssignment.gradeNumber": "Note {{number}}",
  "gradeAssignment.grade": "Note",

  // Evaluation Page
  "evaluation.noDataToSave": "Keine Daten zum Speichern vorhanden",
  "evaluation.dataSaved": "Daten erfolgreich gespeichert!",
  "evaluation.saveFailed": "Speichern fehlgeschlagen",
  "evaluation.saveError": "Fehler beim Speichern aufgetreten",
  "evaluation.failedKeyword": "Fehlgeschlagen",
  "evaluation.errorKeyword": "Fehler",
  "evaluation.saving": "💾 Speichern...",

  // Product Registration
  "productRegistration.registeredItems": "Registrierte Bewertungsobjekte ({{count}})",
  "productRegistration.encryptedBadge": "🔒 Verschlüsselt",
  "productRegistration.encryptedTitle": "Verschlüsselt",
  "productRegistration.previewTitle": "{{title}} Vorschau",
  "productRegistration.editTitle": "{{title}} bearbeiten",
  "productRegistration.deleteTitle": "{{title}} löschen",

  // CSV Export
  "csvExport.export": "CSV-Export",
  
  // Missing translations
  "evaluation.loadError": "Fehler beim Laden des Projekts",
  "evaluation.loadingProject": "Projekt wird geladen...",
  
  // Invitation page
  "invitation.invalidOrExpired": "Ungültige oder abgelaufene Einladung",
  "invitation.invalidTitle": "Ungültige Einladung",
  "invitation.invalidDescription": "Dieser Einladungslink ist ungültig.",
  "invitation.backToDashboard": "Zurück zum Dashboard",
  "invitation.acceptedTitle": "Einladung angenommen",
  "invitation.acceptedDescription": "Sie haben erfolgreich an der Zusammenarbeit teilgenommen.",
  "invitation.redirecting": "Weiterleitung zum Dashboard...",
  "invitation.goToDashboard": "Zum Dashboard gehen",
  "invitation.description": "Sie haben eine Einladung zur Zusammenarbeit für ein Projekt erhalten.",
  "invitation.acceptQuestion": "Möchten Sie diese Einladung annehmen?",
  "invitation.processing": "Wird verarbeitet...",
  "invitation.decline": "Ablehnen",
  "invitation.capabilitiesTitle": "Berechtigungen des Mitarbeiters",
  "invitation.capability1": "Projekte anzeigen und bearbeiten",
  "invitation.capability2": "Bewertungen durchführen und ändern",
  "invitation.capability3": "Berichte generieren und exportieren",
  "invitation.capability4": "Andere Mitglieder einladen",
  "invitation.capability5": "Projekteinstellungen ändern",
  
  // RubricGeneration
  "rubricGeneration.generation.generatingDescription": "Analyse von Kriterien und Produkten zur Generierung der optimalen Bewertungsrubrik...",
  "rubricGeneration.generation.step1": "Analyse der Bewertungskriterien",
  "rubricGeneration.generation.step2": "Analyse der Produktmerkmale",
  "rubricGeneration.generation.step3": "Generierung der Bewertungsrubrik",
  "rubricGeneration.criterionSelector.title": "Kriterien auswählen",
  "rubricGeneration.display.editCellAria": "Zelle bearbeiten",
  
  // Report
  "report.noRubricDescriptions": "Keine Rubrikbeschreibungen verfügbar",
  "report.commentGenerationFailed": "Fehler beim Generieren des Kommentars",
  "report.allEvaluations": "Alle Bewertungen",
  "preview.openInNewTab": "In neuem Tab öffnen",
  "report.generateComment": "Kommentar generieren",
  "report.pdfGeneration.generating": "PDF wird generiert",
  "report.pdfGeneration.generatingDescription": "PDF-Berichte für alle Produkte werden erstellt...",
  "report.pdfGeneration.step1": "Bewertungsdaten sammeln",
  "report.pdfGeneration.step2": "PDF-Layout generieren",
  "report.pdfGeneration.step3": "Bericht finalisieren",
  "report.generatingPdf": "PDF wird generiert...",
  "report.downloadAllPdf": "Alle PDFs herunterladen",
  "report.backToQuick": "Zurück zur Schnellbewertung",
  "report.generatingPdfDescription": "PDF-Bericht wird generiert. Dies kann einen Moment dauern...",
  "report.pdfStep1": "Bewertungsdaten sammeln",
  "report.pdfStep2": "PDF-Layout erstellen",
  "report.pdfStep3": "Bericht finalisieren",
  
  // Product Registration
  "productRegistration.error.encryptionError": "Verschlüsselungsfehler aufgetreten",
  "productRegistration.quickInput.placeholder": "Produktnamen oder Details eingeben (eines pro Zeile)",
  "productRegistration.quickInput.hint": "Sie können mehrere Elemente gleichzeitig einfügen. Leere Zeilen werden ignoriert.",
  "productRegistration.quickInput.disable": "Zum detaillierten Eingabemodus wechseln",
  "productRegistration.quickInput.enable": "Zum Schnelleingabemodus wechseln",
  "productRegistration.mode.detailed": "Detaillierter Modus",
  "productRegistration.mode.quick": "Schnellmodus",
  "productRegistration.quickInput.collectDetails": "Details sammeln",
  "productRegistration.emptyHint": "Fügen Sie mindestens ein Produkt hinzu, um fortzufahren",
  "productRegistration.form.modalTitle": "Produkt bearbeiten",
  
  // Grade Assignment
  "gradeAssignment.distribution.doubleClickToView": "Doppelklick für Detailansicht",
  
  // Criteria Extraction
  "criteriaExtraction.inputFormTitle": "Eingabe der Bewertungskriterien",
  "criteriaExtraction.inputFormSubtitle": "Geben Sie die Bewertungskriterien für Ihre Bewertung ein",
  "criteriaExtraction.productDescriptionsLabel": "Produktbeschreibungen",
  "criteriaExtraction.productDescriptionPlaceholder": "Produktbeschreibung eingeben...",
  "criteriaExtraction.removeDescription": "Beschreibung entfernen",
  "criteriaExtraction.criteriaListTitle": "Liste der Bewertungskriterien",
  "criteriaExtraction.criterionTitlePlaceholder": "Kriterientitel eingeben",
  "criteriaExtraction.criterionDescriptionPlaceholder": "Kriterienbeschreibung eingeben",
  "criteriaExtraction.addCriterionCard": "Neues Kriterium hinzufügen",
  "criteriaExtraction.editCriterion": "Kriterium bearbeiten",
  "criteriaExtraction.deleteCriterion": "Kriterium löschen",
  "criteriaExtraction.extracting": "Kriterien werden extrahiert",
  "criteriaExtraction.extractingDescription": "Ihre Eingabe wird analysiert, um Bewertungskriterien zu extrahieren...",
  "criteriaExtraction.step1": "Inhalt analysieren",
  "criteriaExtraction.step2": "Wichtige Kriterien identifizieren",
  "criteriaExtraction.step3": "Ergebnisse organisieren",
  "criteriaExtraction.quickInputPlaceholder": "Bewertungskriterien eingeben oder Inhalt einfügen, um Kriterien zu extrahieren...",
  "criteriaExtraction.addCriterionModalTitle": "Neues Kriterium hinzufügen",
  "criteriaExtraction.criterionTitleLabel": "Kriterientitel",
  "criteriaExtraction.criterionDescriptionsLabel": "Kriterienbeschreibungen",
  "criteriaExtraction.removeCriterionDescription": "Beschreibung entfernen",
  "criteriaExtraction.addCriterionDescriptionButton": "Beschreibung hinzufügen",
  "criteriaExtraction.addCriterionConfirmButton": "Kriterium hinzufügen",
  
  // Comparative Evaluation Quick
  "comparativeEvaluationQuick.cursor.nextStep": "Zum nächsten Schritt",
  "comparativeEvaluationQuick.cursor.nextCriterion": "Zum nächsten Kriterium",
  
  // Preview
  "preview.loadErrorDetail": "Fehler beim Laden der Vorschau",
  "preview.invalidUrl": "Ungültige URL",
  "preview.invalidUrlDetail": "Bitte geben Sie eine gültige URL ein",
  "preview.loading": "Wird geladen...",
  "preview.loadError": "Fehler beim Laden",
  "preview.pageLoadError": "Seite konnte nicht geladen werden",
  "preview.comment": "Kommentar",
  "preview.commentPlaceholder": "Fügen Sie Ihren Kommentar hinzu...",
  
  // Google Drive
  "googleDrive.searchPlaceholder": "Dateien suchen...",
  "googleDrive.allTypes": "Alle Typen",
  "googleDrive.documents": "Dokumente",
  "googleDrive.spreadsheets": "Tabellenkalkulationen",
  "googleDrive.presentations": "Präsentationen",
  "googleDrive.sortByName": "Name",
  "googleDrive.sortByModified": "Geändert",
  "googleDrive.searchResults": "Suchergebnisse für \"{{query}}\"",
  "googleDrive.selectAll": "Alle auswählen",
  "googleDrive.clearSelection": "Auswahl aufheben",
  "common.folder": "Ordner",
  "googleDrive.noSearchResults": "Keine Ergebnisse gefunden",
  
  // Dashboard
  "dashboard.enterProjectName": "Projektname eingeben",
  
  // AutoSave
  "autoSave.enable": "Automatisches Speichern aktivieren",
  "autoSave.currentSetting": "Aktuelle Einstellung:",
  "autoSave.descriptionShort": "Daten werden automatisch gespeichert",
  "autoSave.descriptionLocal": "Wird auch im lokalen Speicher gespeichert",
  "autoSave.descriptionError": "Daten bleiben bei Fehlern erhalten",
  
  // Weight
  "weight.currentTotal": "Aktuelle Summe:",
  
  // CSV Export
  "csvExport.templateRequired": "Bitte geben Sie eine Vorlage ein",
  "csvExport.exportFailed": "Export fehlgeschlagen",
  "csvExport.sampleComment": "Dies ist ein Beispielkommentar",
  "csvExport.currentUser": "Aktueller Benutzer",
  "csvExport.title": "CSV-Export",
  "csvExport.exportStatus": "Exportstatus",
  "csvExport.remaining": "Verbleibend:",
  "csvExport.unlimited": "Unbegrenzt",
  "csvExport.templateLabel": "Exportvorlage",
  "csvExport.templatePlaceholder": "Geben Sie Ihre Vorlage ein...",
  "csvExport.templateHelp": "Erstellen Sie eine Vorlage mit den verfügbaren Variablen",
  "csvExport.availablePlaceholders": "Verfügbare Variablen",
  "csvExport.preview": "Vorschau",
  "csvExport.filename": "Dateiname",
  "csvExport.format": "Format",
  "csvExport.includeHeader": "Header einschließen",
  "csvExport.exporting": "Wird exportiert...",
  
  // Rubric Generation Dialog
  "rubricGeneration.differenceDialog.title": "Unterschiede erklären",
  "rubricGeneration.differenceDialog.progress": "Frage {{current}} von {{total}}",
  "rubricGeneration.differenceDialog.question": "Was unterscheidet \"{{gradeA}}\" von \"{{gradeB}}\" für {{criterion}}?",
  "rubricGeneration.differenceDialog.hint": "Bitte beschreiben Sie die spezifischen Unterschiede zwischen diesen Bewertungsstufen.",
  "rubricGeneration.differenceDialog.placeholder": "Zum Beispiel: Stufe A zeigt vollständiges Verständnis, während Stufe B teilweises Verständnis zeigt...",
  "rubricGeneration.differenceDialog.skipAndGenerate": "Überspringen und generieren",
  "rubricGeneration.differenceDialog.skip": "Überspringen",
  "rubricGeneration.differenceDialog.completeAndGenerate": "Abschließen und generieren",
  "rubricGeneration.differenceDialog.next": "Weiter",
  
  // Product Registration
  "productRegistration.noDetailProvided": "Keine Details angegeben",
  "productRegistration.detailsDialog.title": "Produktdetails",
  "productRegistration.detailsDialog.progress": "Produkt {{current}} von {{total}}",
  "productRegistration.detailsDialog.productTitle": "{{title}}",
  "productRegistration.detailsDialog.detailLabel": "Details",
  "productRegistration.detailsDialog.detailPlaceholder": "Produktdetails oder Beschreibung eingeben...",
  "productRegistration.detailsDialog.linkLabel": "Referenzlink (optional)",
  "productRegistration.detailsDialog.linkPlaceholder": "https://example.com/product",
  "productRegistration.detailsDialog.hint": "Geben Sie Details an, die bei der Bewertung helfen. Sie können überspringen, wenn nicht erforderlich.",
  "productRegistration.detailsDialog.skipAndComplete": "Alles überspringen und abschließen",
  "productRegistration.detailsDialog.skip": "Überspringen",
  "productRegistration.detailsDialog.complete": "Abschließen",
  "productRegistration.detailsDialog.next": "Weiter",
  "productRegistration.edit.modalTitle": "Produkt bearbeiten",
  
  // Criteria Extraction Modal
  "criteriaExtraction.edit.modalTitle": "Kriterium bearbeiten",
  "criteriaExtraction.form.titleLabel": "Titel",
  "criteriaExtraction.edit.titlePlaceholder": "Kriterientitel eingeben",
  "criteriaExtraction.form.descriptionLabel": "Beschreibung",
  "criteriaExtraction.edit.descriptionPlaceholder": "Kriterienbeschreibung eingeben",
  "criteriaExtraction.form.addDescription": "Beschreibung hinzufügen",
  "criteriaExtraction.edit.save": "Speichern",
  "criteriaExtraction.edit.cancel": "Abbrechen",
  
  // Grade Assignment
  "gradeAssignment.dragOrDoubleClick": "Grenzen ziehen oder Produkte doppelklicken zum Anpassen",
  
  // Product Registration Import
  "productRegistration.import.sectionTitle": "Importieren",
  "productRegistration.import.googleDrive": "Google Drive",
  "productRegistration.import.localTitle": "Aus lokalen Dateien importieren",
  "productRegistration.import.localLabel": "Aus lokalen Dateien importieren",
  "productRegistration.import.local": "Lokale Dateien",
  
  // Final missing translations
  "productRegistration.import.csvShort": "CSV",
  "productRegistration.export.sectionTitle": "Exportieren",
  "productRegistration.export.template": "Vorlage",
  "localFolderBrowser.loading": "Wird geladen...",
  "localFolderBrowser.loadingWithFile": "{{file}} wird geladen...",
  "localFolderBrowser.title": "Lokale Dateien auswählen",
  "localFolderBrowser.searchPlaceholder": "Dateien suchen...",
  "localFolderBrowser.selectAll": "Alle auswählen",
  "localFolderBrowser.clearSelection": "Auswahl aufheben",
  "localFolderBrowser.selectedCount": "{{count}} ausgewählt",
  "localFolderBrowser.noFilesFound": "Keine Dateien gefunden",
  "localFolderBrowser.dropzone.text": "Dateien hier ablegen oder klicken zum Auswählen",
  "localFolderBrowser.dropzone.acceptedFormats": "Akzeptierte Formate: .txt, .csv, .docx, .pdf, .xlsx",
  "localFolderBrowser.cancel": "Abbrechen",
  "localFolderBrowser.import": "Importieren",
  
  // Evaluation guidance messages
  "evaluation.guidance.registerProducts": " Bitte registrieren Sie die zu bewertenden Produkte",
  "evaluation.guidance.completeRegistration": " Schließen Sie die Produktregistrierung ab und klicken Sie auf 'Weiter'",
  "evaluation.guidance.extractCriteria": " Bitte extrahieren Sie Bewertungskriterien oder fügen Sie diese manuell hinzu",
  "evaluation.guidance.confirmCriteria": " Überprüfen und bearbeiten Sie die Kriterien, dann klicken Sie auf 'Weiter'",
  "evaluation.guidance.placeProducts": "💡 Platzieren Sie mindestens {{count}} Produkte für jedes Kriterium",
  "evaluation.guidance.placeMoreProducts": "💡 Platzieren Sie {{remaining}} weitere Produkte für das Kriterium '{{criterionTitle}}'",
  "evaluation.guidance.comparisonComplete": " Erforderliche Vergleiche abgeschlossen. Klicken Sie auf 'Weiter' für die Notenzuweisung",
  "evaluation.guidance.setGrades": "💡 Bitte legen Sie die Noten (A, B, C, etc.) für '{{criterionTitle}}' fest",
  "evaluation.guidance.gradesComplete": " Notenzuweisung abgeschlossen. Klicken Sie auf 'Weiter' zum Generieren der Rubrik",
  "evaluation.guidance.rubricGenerated": " Die Rubrik wurde generiert. Klicken Sie auf 'Weiter' um fortzufahren",
  "evaluation.guidance.generateRubric": " Bitte generieren Sie die Rubrik",
  "evaluation.guidance.startEvaluation": "💡 Beginnen wir mit der Bewertung! Klicken Sie einfach, um Elemente zu platzieren",
  "evaluation.guidance.progress25": "💡 Großartiger Fortschritt! Fast zur Hälfte fertig ({{progress}}% abgeschlossen)",
  "evaluation.guidance.progress50": "💡 Über die Hälfte! Weiter so ({{progress}}% abgeschlossen)",
  "evaluation.guidance.progress75": "💡 75% abgeschlossen! Das Ziel ist in Sicht",
  "evaluation.guidance.almostDone": "💡 Fast fertig! Nur noch {{unplacedCount}} Elemente übrig",
  "evaluation.guidance.allComplete": " Alle Bewertungen abgeschlossen. Klicken Sie auf 'Weiter' zum Generieren des Berichts",
  "evaluation.guidance.downloadReport": " Bitte laden Sie den Bericht herunter oder teilen Sie ihn"
};